export type ToggleLike = 'True' | 'False' | boolean | undefined

export const isToggleEnabled = (value: ToggleLike): boolean => value === true || value === 'True'
